
import { defineComponent } from "vue";
import { Select2Event } from "Models";
export default defineComponent({
  emits: ["changed", "update:modelValue"],
  props: {
    borderClass: Object,
    placeholder: String,
    options: Array,
    modelValue: {},
    modelModifiers: {
      default: () => ({}),
    },
    isEditor: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      itemSelected : ""
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(val) {
        if (!!val) {
          this.itemSelected = val;
        }
      },
    }
  },
  methods: {
    selectEvent($event: Select2Event) {
      this.$emit("changed", $event);
      this.$emit("update:modelValue", $event.id);
    },
  },
});
